
import { defineComponent } from "@vue/runtime-core";
import Landing from "./views/Landing.vue";

export default defineComponent({
  components: {
    Landing,
  }
})
